export const ONBOARDING_MODULE_METADATA = {
  workspaceTour: {
    code: "workspace-tour",
    version: "1.0.0"
  },
  exploreDataset: {
    code: "explore-dataset",
    version: "1.0.0"
  },
  bringYourOwnData: {
    code: "bring-your-own-data",
    version: "1.0.0"
  }
} as const;

export const ONBOARDING_MODULE_VERSION_BY_CODE: Record<string, string> =
  Object.values(ONBOARDING_MODULE_METADATA).reduce<Record<string, string>>(
    (acc, module) => {
      acc[module.code] = module.version;
      return acc;
    },
    {}
  );

export const getOnboardingModuleVersion = (
  code: string | null | undefined
): string | null =>
  code ? (ONBOARDING_MODULE_VERSION_BY_CODE[code] ?? null) : null;
